module.exports = __webpack_public_path__ + "static/media/person.adc59c08.png";